import React from 'react'
import FooterHead from './FooterHead';
import FooterBody from './FooterBody';
import FooterFoot from './FooterFoot';
function Footer() {
  return (
    <footer>
        <FooterHead/>
        <FooterBody />
        <FooterFoot />

    </footer>
  )
}

export default Footer;